// Importazioni necessarie
import Dashboard from "layouts/dashboard";

import { I18n } from "@aws-amplify/core";  // Importa I18n
import TemplateBox from "components/TemplateBox";
import History from "layouts/history";
import Profile from "layouts/profile";
// Imposta la lingua in base alla selezione memorizzata in localStorage
const lang = localStorage.getItem("language");
if (lang) {
  I18n.setLanguage(lang);
}

// Rotte con I18n.get() per ottenere le traduzioni
const routes = [
  {
    type: "route",
    name: I18n.get("dashboard"),  // Traduzione del nome della rotta
    key: "dashboard",
    route: "/dashboard",
    icon: <TemplateBox component="i" color="primary" fontSize="14px" className="ni ni-tv-2" />,
    component: <Dashboard />,
  },
  {
    type: "route",
    name: I18n.get("history"),  // Traduzione del nome della rotta
    key: "history",
    route: "/history",
    icon: <TemplateBox component="i" color="primary" fontSize="14px" className="ni ni-tv-2" />,
    component: <History/>,
  },
  {
    type: "route",
    name: I18n.get("users"),  // Traduzione del nome della rotta
    key: "users",
    route: "/users",
    icon: <TemplateBox component="i" color="primary" fontSize="14px" className="ni ni-tv-2" />,
    component: <Profile/>,
  },
  
];

export default routes;
